import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import MaskedInput from 'react-text-mask'

import InputHOC from './HOC/Input'
import style from './Input.scss'

export class Input extends Component {
  state = {}

  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
    type: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    autoFocus: PropTypes.bool,
    checked: PropTypes.bool,
    invalid: PropTypes.bool,
    autoComplete: PropTypes.oneOf(['on', 'off']),
    className: PropTypes.string,
    size: PropTypes.string,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onChange: PropTypes.func,
    mask: PropTypes.array,
  }

  static defaultProps = {
    disabled: false,
    readOnly: false,
    autoComplete: 'on',
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.input.focus()
    }
  }

  render() {
    const { className, size, invalid, ...others } = this.props

    const componentClass = cx({
      [style.xl]: size === 'xl',
      [style.error]: invalid,
      [className]: className,
    })

    const props = {
      className: componentClass,
      ...others,
      ref: (input) => {
        this.input = input
      },
    }

    return this.props.mask && this.props.mask.length ? <MaskedInput showMask {...props} /> : <input {...props} />
  }
}

export default InputHOC(Input)



// WEBPACK FOOTER //
// ./src/components/Common/Input.js